import { useEffect } from 'react';

import Router from 'next/router';

function saveScrollPos(url) {
  const scrollPos = { x: window.scrollX, y: window.scrollY };
  sessionStorage.setItem(url, JSON.stringify(scrollPos));
}

function restoreScrollPos(url) {
  const scrollPos = JSON.parse(sessionStorage.getItem(url));
  if (scrollPos) {
    window.scrollTo(scrollPos.x, scrollPos.y);
  }
}

function removeScrollPos(url) {
  sessionStorage.removeItem(url);
}

export default function useScrollRestoration(
  router,
  { scrollOnRefresh = false, toRoutes = [] }
) {
  useEffect(() => {
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
      /*
       * Scrolls to the page after refresh
       */
      if (scrollOnRefresh) {
        restoreScrollPos(router.asPath);
      }

      const onRouteChangeStart = url => {
        if (
          !toRoutes.length ||
          toRoutes.some(toRoute => url?.includes(toRoute))
        ) {
          saveScrollPos(router.asPath);
        } else {
          removeScrollPos(router.asPath);
        }
      };

      const onRouteChangeComplete = url => {
        restoreScrollPos(url);
      };

      Router.events.on('routeChangeStart', onRouteChangeStart);
      Router.events.on('routeChangeComplete', onRouteChangeComplete);

      return () => {
        Router.events.off('routeChangeStart', onRouteChangeStart);
        Router.events.off('routeChangeComplete', onRouteChangeComplete);
      };
    }
  }, [router, scrollOnRefresh, toRoutes]);
}
